import React from 'react'

const Pagination = (props) => {
  const {arr,page,pagination,handlePagesDecrease,FetchDataOnPages,getSearch,handlePagesIncrease,setGetSearch,setPagination}=props
   console.log("page:",page);
  return (
    <>
        <div className="pagination">
              <a onClick={()=>{
                handlePagesDecrease()
                }}>
                <span>
                  <i className="fa fa-caret-left" aria-hidden="true" />
                </span>
              </a>
              {arr?.map((item, index) => {
                return (
                  <a
                    onClick={() => FetchDataOnPages(item)}
                    className={page === item && "active"}
                    key={index}
                  >
                    {item}
                  </a>
                );
              })}
              <a onClick={()=>handlePagesIncrease()}>
                <span>
                  <i className="fa fa-caret-right" aria-hidden="true" />
                </span>
              </a>
            </div>
    </>
  )
}

export default Pagination
